export function getDigitFromSessionId(uuid: string) {
	// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
	return Math.floor((parseInt(uuid.at(-1)!, 16) * 10) / 16);
}
